import { IonCol, IonRow, IonText, useIonToast } from '@ionic/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import Cropper from 'react-easy-crop';
import { Modal } from 'react-responsive-modal';

import ActionButton from '../../../components/button/ActionButton';
import InputItem from '../../../components/input/InputItem';
import { UploadImagePostAction } from '../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';

import './AvatarImage.css';
import 'react-responsive-modal/styles.css';
import { isWebView, passToWebView } from '../../../library/Funcs';

interface Props {
    form: any,
    setForm: any,
    defaultImage: string
}

const AvatarImage: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();
    const avatarFileRef = useRef<HTMLInputElement>(null);

    const [selectedFile, setSelectedFile] = useState();
    const [selectedAvatar, setSelectedAvatar] = useState("");
    const [cropShow, setCropShow] = useState(false);
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [cropDetails, setCropDetails] = useState({ x: 0, y: 0, width: 0, height: 0 });

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCropDetails({ x: croppedAreaPixels.x, y: croppedAreaPixels.y, width: croppedAreaPixels.width, height: croppedAreaPixels.height })
    }, [])

    const dispatch = useAppDispatch()
    const formUploadImage = useAppSelector(state => state.uploadAvatar)
    const { form_loading, resp } = formUploadImage

    const avatarFileSelectHandler = async () => {
        if (isWebView()) {
            await passToWebView("requestCameraPermission", "");
        }
        
        avatarFileRef.current?.click();
    }

    const hideCropModal = () => {
        setCropShow(false);
    }

    const avatarChangeHandler = (e: any) => {
        let image = e.target.files[0];

        setSelectedFile(image);
        setSelectedAvatar(URL.createObjectURL(image));
        setCropShow(true);
    }

    const uploadAvatarHandler = () => {
        hideCropModal();

        dispatch(UploadImagePostAction("avatar", selectedFile, cropDetails.x.toString(), cropDetails.y.toString(), cropDetails.width.toString(), cropDetails.height.toString()));
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    const form = { ...props.form }
                    form.avatar.value = resp.avatar;
                    props.setForm(form);
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    return <>
        <IonRow>
            <IonCol>
                <img className="avatar" width={80} src={props.form.avatar.value?.length == 0 ? props.defaultImage : props.form.avatar.value + '?' + new Date().getTime()} />
            </IonCol>
            <IonCol>
                <div className="upload-container">
                    <ActionButton text="ارسال تصویر پرسنلی" compact color='dark' loading={form_loading} click={avatarFileSelectHandler} />

                    <input type="file" accept=".jpg, .jpeg, .png" ref={avatarFileRef} onClick={(e: any) => e.target.value = null} onChange={avatarChangeHandler} />

                    <InputItem name="avatar" type="hidden" />
                </div>
            </IonCol>
        </IonRow>

        <Modal open={cropShow} onClose={hideCropModal} center showCloseIcon={false} classNames={{ modalContainer: "crop-avatar-modal" }}>
            <div className="crop-avatar">
                <Cropper
                    image={selectedAvatar}
                    crop={crop}
                    zoom={zoom}
                    aspect={3 / 4}
                    maxZoom={6}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom} />

                <div className="title">
                    <IonText>محدوده چهره خود را تنظیم کنید.</IonText>
                </div>

                <div className="button-container">
                    <ActionButton text="ارسال تصویر پرسنلی" compact click={uploadAvatarHandler} />
                </div>
            </div>
        </Modal>
    </>
}

export default AvatarImage